import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import HomeIcon from '@mui/icons-material/Home';
import NotesIcon from '@mui/icons-material/Notes';
import { FieldValidationType } from '../../../sic-lib/enums/FieldValidationType';

interface Props {
    validationType: FieldValidationType;
}

export default function ContactFieldIcon({ validationType }: Props) {
    switch (validationType) {
        case FieldValidationType.usMobilePhone:
            return <CallIcon color="action" />;
        case FieldValidationType.email:
            return <EmailIcon color="action" />;
        case FieldValidationType.address:
            return <HomeIcon color="action" />;
        case FieldValidationType.dollars:
            return <AttachMoneyIcon color="action" />;
        case FieldValidationType.other:
            return <NotesIcon color="action" />;
        case FieldValidationType.years:
        case FieldValidationType.date:
        default:
            return <EventIcon color="action" />;
    }
}
